import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhTW from './locales/zh-TW.json';
import en from './locales/en.json';

const LANG_KEY = 'event-ui-lang';

i18n.use(initReactI18next).init({
  resources: {
    'zh-TW': { translation: zhTW },
    en: { translation: en },
  },
  lng: localStorage.getItem(LANG_KEY) || 'zh-TW',
  fallbackLng: 'zh-TW',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LANG_KEY, lng);
  document.documentElement.lang = lng === 'zh-TW' ? 'zh-TW' : 'en';
});

export default i18n;
